var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"binds-stepper"},[(_vm.BindsSteppers.isVertical)?_c('binds-step-header',{attrs:{"index":_vm.id}}):_vm._e(),_c('div',{staticClass:"binds-stepper-content",class:{ 'binds-active': !_vm.BindsSteppers.syncRoute && _vm.id === _vm.BindsSteppers.activeStep }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }